import { Component } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { DatabaseHealth, LinkedServerInfo, QueryStat, ServerConnection, ServerDetails, SessionInfo, TableInsight } from 'src/app/core/models/dbserverinfo';
import { HealthService } from 'src/app/core/services/health.service';
import { SyncConfigService } from 'src/app/core/services/sync-config.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-db-server-info',
  standalone: false,
  templateUrl: './db-server-info.component.html',
  styleUrl: './db-server-info.component.scss'
})
export class DbServerInfoComponent {
  constructor(
    private healthService: HealthService,
    public syncConfig: SyncConfigService,
    private spinner: NgxSpinnerService

  ) {}

  ngOnInit(): void {
    this.getDbServerInfo();
  }

  dataReloadSubscription: Subscription;
  dbServerDetails: ServerDetails[] = [];
  serverConnections: ServerConnection[] = [];
  serverSessionInfoes: SessionInfo[] = [];
  queryStats: QueryStat[] = [];
  tablesAndDataInsights: TableInsight[] = [];
  databaseHealthInfo: DatabaseHealth[] = [];
  linkedServerInfo: LinkedServerInfo[] = [];
  totalNumberOfTables: number = 0;

  getDbServerInfo() {
    this.spinner.show('jobListLoad'); 

    this.healthService.getDbServerInfoService().subscribe({
      next: (data: any) => {
        let result = JSON.parse(JSON.stringify(data));
        this.dbServerDetails = result?.dbServerDetails;
        this.serverConnections = result?.serverConnections;
        this.serverSessionInfoes = result?.serverSessionInfoes;
        this.queryStats = result?.queryStats;
        this.tablesAndDataInsights = result?.tablesAndDataInsights;
        this.databaseHealthInfo = result?.databaseHealthInfo;
        this.linkedServerInfo = result?.linkedServerInfo;
        
        if(this.tablesAndDataInsights) {
          this.totalNumberOfTables = this.tablesAndDataInsights[0].totalTables;
        }
        this.spinner.hide('jobListLoad'); 

      },
      error: (err) => {
        console.error(err);
        this.spinner.hide('jobListLoad');

      },
    });
  }
}
